<template>
  <div class="no-internet-access">
    <div class="content">
      <div style="text-align: center;">
      <img src="@/assets/image/empty@3x.png" width="220" alt="" style="margin-bottom: 20px;">
    <div class="des">
      {{ $t("personalCenter.noNetwork") }}
    </div>
  </div>
  </div>
</div>
</template>  
<script setup>
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();
</script>

<style lang="scss" scoped>.no-internet-access {
  min-height: 100vh;
  background-color: #111;
  padding-top: 24px;
  padding-bottom: 120px;

  .content {
    width: 1105px;
    height: 1074px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.06);
    margin: 0 auto;
    padding-top: 345px;
  }
}


  .des {
    margin-top: 20px;
    font-size: 16px;
    color: #ffffff48;
    transform: translateY(-30px);
  }
</style>